import React, { useState } from "react";
import {
  LightModeOutlined,
  DarkModeOutlined,
  Fullscreen,
  FullscreenExit,
  SettingsOutlined,
  ArrowDropDownOutlined,
  PersonOutline,
  Refresh,
} from "@mui/icons-material";
import FlexBetween from "components/FlexBetween";
import { useDispatch } from "react-redux";
import { setMode } from "state";
import { logout } from "state/authSlice";

import {
  AppBar,
  Box,
  Button,
  IconButton,
  Menu,
  MenuItem,
  Toolbar,
  Typography,
  useTheme,
} from "@mui/material";

const Navbar = ({ user, isSidebarOpen, setIsSidebarOpen }) => {
  const dispatch = useDispatch();
  const theme = useTheme();

  const [anchorEl, setAnchorEl] = useState(null);
  const isOpen = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  // const [value, setValue] = useState(null);
  // const [searchData, setSearchData] = useState([]);

  // const { data, isFetching } = useSearchInventoryQuery(
  //   {
  //     query: value,
  //   },
  //   {
  //     skip: value === null || value === "",
  //     refetchOnMountOrArgChange: true,
  //   }
  // );
  // useEffect(() => {
  //   if (data && !isFetching) {
  //     setSearchData(data);
  //   }
  // }, [data, isFetching]);

  return (
    <AppBar
      sx={{
        position: "static",
        background: "none",
        boxShadow: "none",
      }}
    >
      <Toolbar sx={{ justifyContent: "space-between" }}>
        {/* LEFT SIDE */}
        <FlexBetween>
          {/* <IconButton onClick={() => setIsSidebarOpen(!isSidebarOpen)}>
            <MenuIcon/>
          </IconButton> */}
          {/* <FlexBetween
            backgroundColor={theme.palette.background.alt}
            borderRadius="9px"
            gap="3rem"
            p="0.1rem 1.5rem"
          >
            <Autocomplete
              freeSolo
              disableClearable
              onInputChange={(event, newValue) => {
                //convert spaces to %2b
                const changedVal = newValue.replace(/ /g, "%2b");
                setValue(changedVal);
              }}
              disablePortal
              options={searchData}
              getOptionLabel={(option) => option.name || ""}
              sx={{
                width: 170,
                color: theme.palette.secondary[900],
              }}
              renderInput={(params) => {
                const { InputLabelProps, InputProps, ...rest } = params;
                return (
                  <InputBase
                    sx={{
                      color: theme.palette.secondary[100],
                      "& .MuiInputBase-input": {
                        padding: "0.5rem 0",
                      },
                      "& .MuiAutocomplete-popper": {
                        backgroundColor: theme.palette.background.default,
                        color: theme.palette.secondary[100],
                      },
                    }}
                    {...params.InputLabelProps}
                    {...params.InputProps}
                    {...rest}
                    placeholder="Search..."
                  />
                );
              }}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  // e.defaultMuiPrevented = true;
                  // navigate(`/search/${value}`);
                }
              }}
              onChange={(event, newValue) => {
                if (newValue && newValue._id) {
                  navigate(`/inventory/${newValue._id}`);
                }
                
              }}
            />
            <IconButton>
              <Search />
            </IconButton>
          </FlexBetween> */}
        </FlexBetween>

        {/* RIGHT SIDE */}
        <FlexBetween>
          {/* reload button */}
          <IconButton onClick={() => window.location.reload()}>
            <Refresh />
          </IconButton>

          <IconButton onClick={() => setIsSidebarOpen(!isSidebarOpen)}>
            {isSidebarOpen ? <Fullscreen /> : <FullscreenExit />}
          </IconButton>
          <IconButton onClick={() => dispatch(setMode())}>
            {theme.palette.mode === "dark" ? (
              <LightModeOutlined />
            ) : (
              <DarkModeOutlined />
            )}
          </IconButton>
          <IconButton>
            <SettingsOutlined />
          </IconButton>

          <FlexBetween>
            <Button
              onClick={handleClick}
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                textTransform: "none",
                gap: "1rem",
              }}
            >
              <PersonOutline
                sx={{
                  color: theme.palette.secondary[300],
                  fontSize: "25px",
                }}
              />

              <Box textAlign="left">
                <Typography
                  fontWeight="bold"
                  fontSize="0.85rem"
                  sx={{ color: theme.palette.secondary[100] }}
                >
                  {user.name}
                </Typography>
                <Typography
                  fontSize="0.75rem"
                  sx={{ color: theme.palette.secondary[200] }}
                >
                  {user.role}
                </Typography>
              </Box>
              <ArrowDropDownOutlined
                sx={{ color: theme.palette.secondary[300], fontSize: "25px" }}
              />
            </Button>
            <Menu
              anchorEl={anchorEl}
              open={isOpen}
              onClose={handleClose}
              anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
              sx={{
                "& .MuiPaper-root": {
                  backgroundColor: theme.palette.background.default,
                  color: theme.palette.secondary[100],
                  width: "10rem",
                },
              }}
            >
              <MenuItem
                onClick={() => {
                  dispatch(logout());
                  handleClose();
                }}
              >
                Log Out
              </MenuItem>
            </Menu>
          </FlexBetween>
        </FlexBetween>
      </Toolbar>
    </AppBar>
  );
};

export default Navbar;
